import { render, staticRenderFns } from "./soldes.vue?vue&type=template&id=702d4ca4&"
import script from "./soldes.vue?vue&type=script&lang=js&"
export * from "./soldes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports